<template src='./role-information.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { hasRoleManageClaim } from '@/router/auth'
import { EventBus } from '@/router/bus'
import { required, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from '@/mixins/validation'

export default {
  components: {
    ContextPage
  },
  mixins: [validationMixin],
  data () {
    return {
      roleId: this.$route.params.roleId,
      editMode: false,
      availableClaims: [],
      role: {
        id: 0,
        initialName: '',
        name: '',
        description: '',
        claims: []
      },
      deleteDialog: false,
      help: {
        details: Vue.$helpConfig.roleDetails
      }
    }
  },
  created () {
    this.editMode = false
    this.setupPage()
  },
  computed: {
    nameErrors () {
      return this.getValidationErrorsByName('name')
    },
    descriptionErrors () {
      return this.getValidationErrorsByName('description')
    },
    canEditRole () {
      return this.role && ((hasRoleManageClaim() && this.role.roleType < 10))
    }
  },
  methods: {
    setupPage () {
      this.retrieveAvailableClaims()
      this.pageLoader = true
      const infoUrl = Vue.$apiConfig.roleDetailsGet + '/' + this.$route.params.roleId
      this.$http.get(infoUrl).then(
        response => {
          this.logConsole(response)
          this.role = response.data.payload
          this.role.initialName = response.data.payload.name
          if (this.role.claims) {
            this.role.claims.forEach(claim => {
              claim.role = null
            })
          }
          this.pageLoader = false
        },
        error => {
          this.formatErrorResponse(error)
          this.pageLoader = false
        }
      )
    },
    retrieveAvailableClaims () {
      this.pageLoader = true
      this.$http.get(Vue.$apiConfig.availableClaimsGet).then(
        response => {
          this.logConsole(response)
          this.availableClaims = response.data.payload
          this.pageLoader = false
        },
        error => {
          this.formatErrorResponse(error)
          this.pageLoader = false
        }
      )
    },
    updateRole () {
      this.pageLoader = true
      this.$http.put(Vue.$apiConfig.updateRolePut, this.role).then(
        response => {
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('userAdministration.updateRoleSuccessful'),
            errors: []
          })
          this.role = response.data.payload
          this.role.initialName = response.data.payload.name
          this.editMode = false
          this.pageLoader = false
        },
        error => {
          this.formatErrorResponse(error)
          this.pageLoader = false
        })
    },
    deleteRole () {
      this.pageLoader = true
      this.$http.delete(Vue.$apiConfig.removeRoleDelete + '/' + this.$route.params.roleId, { body: this.role }).then(
        response => {
          Vue.use(response)
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('userAdministration.deleteRoleSuccessful'),
            errors: []
          })
          this.pageLoader = false
          this.deleteDialog = false
          this.$router.push('administration/role/management')
        },
        error => {
          this.formatErrorResponse(error)
          this.pageLoader = false
        })
    },
    validateBeforeRoleSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.updateRole()
    },
    getValidationErrorsByName (name) {
      if (!this.$v.role[name].$dirty) return []
      return this.getValidationErrors('role').filter((x) => { return x.field === name }).map(x => x.msg)
    }
  },
  validations: {
    role: {
      name: {
        required,
        maxLength: maxLength(32)
      },
      description: {
        required,
        maxLength: maxLength(128)
      }
    }
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
</style>
